import React, { useRef, useState } from "react";

const Overlays = ({ setting, setSetting, setIsSubmit, loader, isSubmit }) => {
  const initialState = {
    selectValue: "",
    inputValue: "",
  };
  const createInitialState = () => ({
    selectValue: "",
    inputValue: "",
  });

  const [rows, setRows] = useState(() => {
    const saved = setting?.overlayParams;
    if (Array.isArray(saved) && saved.some((r) => r && r.selectValue)) {
      // Preserve previously-applied overlays when modal/component remounts
      return saved;
    }
    return [initialState];
  });

  const handleSubmit = () => {
    const allSelectValuesEmpty = rows.every((item) => item.selectValue === "");
    if (allSelectValuesEmpty) {
      handleClearAll();
    }
    const hasSelection = rows.some((row) => row.selectValue !== "");

    if (hasSelection) {
      setSetting({ ...setting, overlayParams: rows });
      setIsSubmit(!isSubmit);
    }
  };

  const handleSelectChange_BKP = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectValue = value;

    // Set default value for the input field based on selected option
    switch (value) {
      case "bb":
        newRows[index].inputValue = "20,2";
        break;
      case "sma":
        newRows[index].inputValue = "50";
        break;
      case "ema":
        newRows[index].inputValue = "50";
        break;
      case "psar":
        newRows[index].inputValue = "0.09,0.2";
        break;
      default:
        newRows[index].inputValue = "";
    }

    // Add a new row if conditions are met
    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }

    handleInputChange(index, newRows[index].inputValue);
    setRows(newRows);
  };

  const handleSelectChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectValue = value;

    const newColor = generateRandomColor();
    newRows[index].color = newColor;

    // Set default value for the input field based on selected option
    switch (value) {
      case "bb":
        newRows[index].inputValue = "20,2";
        break;
      case "sma":
        newRows[index].inputValue = "50";
        break;
      case "ema":
        newRows[index].inputValue = "50";
        break;
      case "psar":
        newRows[index].inputValue = "0.09,0.2";
        break;
      default:
        newRows[index].inputValue = "";
    }

    // Add a new row if conditions are met
    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }

    handleInputChange(index, newRows[index].inputValue);

    setRows(newRows);
  };

  const generateRandomColor_BKP = (existingColors) => {
    // Function to generate a random HSL color
    const randomHSLColor = () => {
      const hue = Math.floor(Math.random() * 360); // Random hue value (0-360)
      const saturation = Math.floor(Math.random() * 50) + 50; // Random saturation value (50-100)
      const lightness = Math.floor(Math.random() * 30) + 50; // Random lightness value (50-80)
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    let newColor;
    const maxAttempts = Math.max(existingColors.length * 1, 10); // Set a maximum of 50 attempts or 10 times the number of existing colors

    for (let i = 0; i < maxAttempts; i++) {
      newColor = randomHSLColor();

      // Check if the new color is significantly different from existing colors
      const isDifferent = existingColors.every((color) => {
        const hsl1 = newColor.match(/(\d+(\.\d+)?)/g).map(Number);
        const hsl2 = color.match(/(\d+(\.\d+)?)/g).map(Number);
        const deltaHue = Math.abs(hsl1[0] - hsl2[0]);
        const deltaSaturation = Math.abs(hsl1[1] - hsl2[1]);
        const deltaLightness = Math.abs(hsl1[2] - hsl2[2]);
        const delta = Math.sqrt(
          deltaHue ** 2 + deltaSaturation ** 2 + deltaLightness ** 2
        );
        return delta >= 150; // Adjust this threshold as needed
      });

      if (isDifferent) {
        return newColor;
      }
    }

    // If no suitable color is found after the maximum attempts, return a fallback color
    return "#000000"; // Fallback to black color
  };

  const generateRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const handleClearAll = () => {
    setRows([initialState]);
    setSetting({
      ...setting,
      clearOverlay: true,
      overlayParams: [],
    });
  };
  const handleInputChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].inputValue = value;
    setRows(newRows);
  };

  const isMobileView = document.body.clientWidth <= 768;
  const overlayOptions = [
    // Client, 3: 'Overlays drop-down change "-----None------" to "Select
    // overlay"'. Same reasoning as the Indicators picker: the empty row is a
    // prompt, not a value called "None".
    { value: "", label: "Select overlay" },
    { value: "bb", label: "Bollinger Bands" },
    { value: "sma", label: "Simple Moving Avg" },
    { value: "ema", label: "Exp Moving Avg" },
    { value: "psar", label: "Parabolic SAR" },
  ];
  return (
    <div className="text-gray-900 rounded col-span-3">
      <div className="">
        <div className="space-y-1">
          <div className="flex flex-row">
            <table className="table-auto" style={{ width: "100%" }}>
              <thead>
                <tr className="">
                {/* 5 */}
                  <td className="font-bold" id="chart-overlays-guide">Overlays</td>
                  <td className=" font-bold" style={{ width: "100px" }}>
                    Parameters
                  </td>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={`overlay-${index}`}>
                    <td>
                      <select
                        id="overlay"
                        value={row.selectValue}
                        onChange={(e) =>
                          handleSelectChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        {/* PLACEHOLDER, NOT A CHOICE.
                            Client: "Select overlay appears as one of the
                            selectable options in the middle of the list. Please
                            remove Select overlay from the dropdown options. Keep
                            Select overlay only as the placeholder text in the
                            input field… there is no reason to have Select
                            Overlay or Indicator in the list on desktop and
                            mobile, a user can click outside the options and has
                            clear all."

                            It sorted into the MIDDLE because it was a real
                            option carrying a real label. `hidden` takes it out
                            of the open list while the closed field still shows
                            it whenever nothing is chosen; `disabled` is the
                            fallback for a browser that ignores `hidden`, and
                            rendering it before the sorted list means that
                            fallback puts it at the top rather than mid-list.

                            The entry STAYS in the options array — the empty
                            value is still what a cleared row holds, and lookups
                            by value resolve against it. */}
                        <option value="" disabled hidden>
                          Select overlay
                        </option>
                        {overlayOptions
                          .filter((option) => option.value !== "")
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td className="w-40">
                      <input
                        type="text"
                        id={index}
                        value={row.inputValue}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        placeholder="Enter parameters"
                        className="text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-row">
            <button
              disabled={!setting.period || !setting.symbol}
              onClick={handleSubmit}
              className="bg-primaryColor text-white rounded p-2 mt-2 mr-2 w-full"
              id={"overlayUpdate"}
            >
              {loader ? "Please wait .." : "Update"}
            </button>
            {/* Client, Indicator Polish 3: "Keep `Update` as the primary button
                and change `Clear All` to an outlined secondary button. The
                outline and 'Clear All' text should be in dark teal; the button
                is white. Do this for the Overlays modal as well."

                Identical to the Indicators modal, and identical to what the
                MOBILE overlays/indicators sheets have always used — this is
                desktop catching up to the treatment already shipped there. */}
            <button
              onClick={handleClearAll}
              className="bg-white text-primaryColor border border-primaryColor rounded p-2 mt-2 ml-2 w-full hover:bg-primaryColor/5"
            >
              {"Clear All"}
            </button>
          </div>
        </div>
        {/* {showWarning && (
          <WarningDialog onClose={() => setShowWarning(false)} />
        )} */}
      </div>
    </div>
  );
};

export default Overlays;
